// export const environment = {
//   production: false,
//   apiUrl: 'https://devapi.eposdeck.com',
// };

export const environment = {
  production: false,
  apiUrl: 'https://devapi.eposdeck.com',
  grpcUrl: 'https://devapi.tradeseel.com',
};
